/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/**
 *
 * OrdersQueue Container
 *
 */

import { useEffect, memo, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useInjectSaga } from '../../../config/utils/injectSaga';
import { useInjectReducer } from '../../../config/utils/injectReducer';
import FormattedMessage from '../../components/TranslationWrapper';
import selectWebsocket from '../Websocket/selectors';
import Modal from '../../components/UI/Modal';
import ModalHeader from '../../components/LedModal/ModalHeader';
import ModalFooter from '../../components/LedModal/ModalFooter';
import ModalContent from '../../components/LedModal/ModalContent';
import reducer from './reducer';
import saga from './saga';
import _, { cloneDeep } from 'lodash';
import makeEditControlQueue from './selectors';
import styled from 'styled-components';
import Input from '../../components/reusable/Input';
import editSettingsList from '../../../config/containers/EditControlModal/editList.js'; // ./config/editList
import { makeSelectLoginState } from '../App/selectors';
import EditOrderView from './generateOrderView.js';
import { Accordion, AccordionItem } from 'react-sanfona';
import { Button, Tabs, Tab, Box, MenuItem } from '@mui/material';
import globalMessages from '../../../config/globalMessages';
import useUnitConverter from '../../../config/utils/hooks/useUnitConverter.js';
import { conversionsConfig } from '../../../config/containers/EditControlModal/conversionsConfig.js';
import { sendToWs } from '../Websocket/actions.js';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import InfoButton from '../../components/InfoButton/index.js';
import WithInfo from '../../components/WithInfo';
import { useEditControlPresence } from './useEditControlPresence';
import jdqueueList from '../../../config/containers/QueueContainers/JoinedDimQueue/jdqueueList.js';
import XButton from '../QueueContainers/components/XButton';
import DailyStatsSettings from './DailyStatsSettings';
import { dailyStatsColorDefaults, normalizeDailyStatsColors, validateDailyStatsColors } from '../../../config/utils/dailyStatsColors';

const dailyStatsFields = Object.keys(dailyStatsColorDefaults);

(props) => <TextField color="primary" {...props} />;

const CustomInputLabel = (props) => (
  <InputLabel
    {...props}
    color="primary"
    sx={{
      color: '#636f83',
      fontWeight: 'bold',
      marginBottom: 0,
      display: 'block',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'auto',
      textAlign: 'center',
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      lineHeight: 1.2,
      maxWidth: '100%'
    }}
  />
);

const CustomCheckbox = (props) => (
  <Checkbox
    {...props}
    color="primary"
    sx={{
      color: '#9aa0a6',
      '& svg': {
        fontSize: 24
      },
      '&.Mui-checked': {
        color: '#0c963a'
      }
    }}
  />
);

const PropertyField = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  text-align: center;
  border-radius: 5px;
  padding: 5px 10px;
  margin-top: 5px;
  width: 12vw;
  min-width: 140px;
  max-width: 240px;
  margin-right: 10px;
  position: relative;
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

export function EditControlModal(props) {
  useInjectReducer({ key: 'editcontrol', reducer });
  useInjectSaga({ key: 'editcontrol', saga });
  const { convertUnit, unitSystem } = useUnitConverter();
  const [openPopoverKey, setOpenPopoverKey] = useState(null);
  // console.log('whatup');

  /* Another way to get project name ( and not from global state) */
  const resolvedConfig = editSettingsList?.default ?? editSettingsList;
  const editSettings = resolvedConfig?.default ?? resolvedConfig;
  const adminRequiredSettings = resolvedConfig?.adminRequired ?? [];
  const superMegaAdminRequiredSettings = resolvedConfig?.superMegaAdminRequired ?? [];
  const hiddenSettings = resolvedConfig?.hidden ?? [];
  const hasDailyStatsSettings = props.action === 'set-settings' && resolvedConfig.dailyStatsSettings;
  const layerFieldsConfig = editSettings ? editSettings.find((setting) => setting?.['set-layer-fields'])?.['set-layer-fields'] : null;
  const layerInfoCherryPick = layerFieldsConfig?.cherryPick ? layerFieldsConfig.cherryPick : [];
  const hasLayerInfoFieldsConfig = layerInfoCherryPick.length > 0;

  const userPrivilege = props?.loginState?.privilege ?? -1;
  const hasSuperMegaAdminPrivilege = userPrivilege >= 4;
  // super mega admin implies admin privileges (see roles.js)
  const hasAdminPrivilege = userPrivilege >= 3 || hasSuperMegaAdminPrivilege;

  const dispatch = useDispatch();
  const openEditModalKey = (_.get(props, 'websocket.modalmanager.modal', []) || []).find((key) => ['modal-edit', 'modal-action', 'generalEdit'].includes(key));
  const modalData = _.get(props, `websocket.modalmanager.submodalInfo.${openEditModalKey}.data`, props?.data);
  useEditControlPresence({ action: props.action, data: modalData, manageLock: true, isOpen: true });
  // const history = useHistory();
  const action = props.action;
  let title = '';
  const fieldIDs = {};
  const productionstatus = _.get(props, 'websocket.websocket.cltstatus.map', null);
  const jdqueueConfig = jdqueueList?.default ?? jdqueueList;

  const [newState, setNewState] = useState({
    activeItems: [],
    fields: [],
    test: true,
    jdName: 'joinedDimensionsNew',
    lastHash: ''
  });
  const [tabIndex, setTabIndex] = useState(0);
  const [settingsErrors, setSettingsErrors] = useState({});
  const [cherryPick, setCherryPick] = useState(undefined);
  const [reverseCherryPick, setReverseCherryPick] = useState(undefined);
  const [tempValues, setTempValues] = useState(() => {
    return Object.keys(fieldIDs).reduce((acc, key) => {
      acc[key] = getValue(fieldIDs[key]) || '';
      return acc;
    }, {});
  });
  const [showInfo, setShowInfo] = useState(false);

  const handleTempValueChange = (inputId, newValue) => {
    const pathTail = inputId[inputId.length - 1];

    if (_.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]) && newValue !== '' && unitSystem != 'metric') {
      const { fromUnit, toUnit, unitType } = _.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]);
      newValue = convertUnit(newValue, unitType, toUnit, fromUnit, 3);
    }

    setTempValues((prev) => {
      const newTempValues = { ...prev };
      _.set(newTempValues, inputId, newValue);
      return newTempValues;
    });
  };

  function handleChange({ activeItems }) {
    setNewState({ activeItems });
  }

  function getCherryPickFor(window) {
    for (let i = 0; i < editSettings.length; i++) {
      if (editSettings[i][window]?.cherryPick) {
        setCherryPick(editSettings[i][window].cherryPick);
        setReverseCherryPick(editSettings[i][window].reverseCherryPick);
        setShowInfo(editSettings[i][window]?.showInfo);
        return;
      } else if (editSettings[i][window]?.reverseCherryPick) {
        setReverseCherryPick(editSettings[i][window].reverseCherryPick);
        setCherryPick(null);
        setShowInfo(editSettings[i][window]?.showInfo);
        return;
      }
    }
    setReverseCherryPick(null);
    setCherryPick(null);
  }

  useEffect(() => {
    getCherryPickFor(action);
  }, [action]);

  useEffect(() => {
    if (cherryPick !== undefined) setNewState(initialize(action));
    if (reverseCherryPick !== undefined) setNewState(initialize(action));
  }, [reverseCherryPick, cherryPick]);

  /* R+Formatted messages parse */
  // var messagesBuild = {};
  // console.log("messagesBuild: ", messagesBuild);
  function checkIfAllowed(level, property) {
    if (action === 'set-settings' && superMegaAdminRequiredSettings.includes(property) && !hasSuperMegaAdminPrivilege) {
      return false;
    } else if (action === 'set-settings' && adminRequiredSettings.includes(property) && !hasAdminPrivilege) {
      return false;
    } else if (hiddenSettings.includes(property)) {
      return false;
    }
    if (cherryPick != null) {
      return level > 0 || cherryPick.indexOf(property) >= 0;
    } else if (reverseCherryPick != null) {
      return level > 0 || reverseCherryPick.indexOf(property) < 0;
    } else {
      return true;
    }
  }

  function initialize(string) {
    const newState = { fields: [] };
    /* -- Settings for edit unique to project -- */
    editSettings.map((setting) => {
      const key = String(Object.keys(setting));
      if (string === key) {
        title = setting[key].title;
        const properties = {};
        setting[key].settings.map((set) => {
          const k = String(Object.keys(set));
          newState.fields.push({ key: k, ...set[k] });
          const type = set[k].type;
          const identifier = set[k].identifier;
          const prefix = _.get(props, 'machineId', '');
          switch (type) {
            case 'status':
              properties[k] = productionstatus != null ? productionstatus[prefix + identifier] : 0;
              break;
            case 'nested-status':
              const childIdent = set[k].childIdent;
              console.log();
              properties[k] = productionstatus != null ? productionstatus[identifier][childIdent] : 0;
              break;
            case 'nested-nested-status':
              const child = set[k].childIdent;
              const childChild = set[k].childChildIdent;
              properties[k] = productionstatus != null ? productionstatus[identifier][child][childChild] : 0;
              break;
            case 'boolStatus':
              properties[k] = _.get(productionstatus, prefix + identifier, null);
              break;
            case 'bool':
              properties[k] = false;
              break;
            case 'value':
              const val = set[k].value;
              properties[k] = val;
              break;
            default:
              break;
          }
        });

        newState.item = properties;
        newState.view = generateViewObject(newState.item, 0, [], true);
        return newState;
      }
    });

    /* -- Settings for edit commonly used along all project -- */
    if (string === 'missing-lamella-request') {
      title = 'Missing lamella request';
      const missingLamellaFields = _.get(jdqueueConfig, 'missingLamellaRequest.fields', []);
      newState.fields = missingLamellaFields;
      const prefix = _.get(props, 'websocket.modalmanager.submodalInfo.modal-edit.data.prefix', '');
      let usedPrefix = '';
      if (prefix.length > 0) {
        usedPrefix = prefix + '-';
      }

      newState.item = {
        layerId: _.get(productionstatus, usedPrefix + 'producing.id', 0),
        numLamellas: 0,
        ...missingLamellaFields.reduce(
          (acc, field) => {
            acc[field.key] = field.defaultValue;
            return acc;
          },
          { urgentRequest: false }
        )
      };
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }

    if (string === 'missing-plate-request') {
      title = 'Missing plate request';
      const prefix = _.get(props, 'websocket.modalmanager.submodalInfo.modal-edit.data.prefix', '');
      let usedPrefix = '';
      if (prefix.length > 0) {
        usedPrefix = prefix + '-';
      }

      newState.item = {
        layerId: _.get(productionstatus, usedPrefix + 'producing.id', 0),
        rawWidth: 0,
        urgentRequest: false
      };
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }

    if (string === 'extra-lamella-request') {
      title = 'Extra lamella request';
      const extraLamellaFields = _.get(jdqueueConfig, 'extraLamellaRequest.fields', []);
      newState.fields = extraLamellaFields;
      let prefix = _.get(props, 'websocket.modalmanager.submodalInfo.modal-edit.data.prefix', '');
      let usedPrefix = '';
      if (prefix.length > 0) {
        usedPrefix = `${prefix}-`;
      } else {
        prefix = 'default';
      }

      if (Array.isArray(extraLamellaFields) && extraLamellaFields.length > 0) {
        newState.item = extraLamellaFields.reduce((acc, field) => {
          if (!field?.key) return acc;

          let sourceValue;

          if (field.source === '{prefix}') {
            sourceValue = prefix;
          } else if (field.source === '{usedPrefix}') {
            sourceValue = usedPrefix;
          } else if (typeof field.source === 'string' && field.source.length > 0) {
            const sourcePath = field.source.replace(/\{usedPrefix\}/g, usedPrefix).replace(/\{prefix\}/g, prefix);
            sourceValue = _.get(productionstatus, sourcePath);
          }

          acc[field.key] = sourceValue !== undefined ? sourceValue : field.defaultValue;
          return acc;
        }, {});
      } else {
        newState.item = {
          lamellaLength: _.get(productionstatus, 'globalSettings.extraLamellaLength', 0),
          numLamellas: 0,
          lamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaWidth', 0),
          lamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaThickness', 0),
          plannedLamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedWidth', 0),
          plannedLamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedThickness', 0),
          woodType: _.get(productionstatus, usedPrefix + 'producing.woodType', ''),
          quality: _.get(productionstatus, usedPrefix + 'producing.quality', ''),
          FJMachine: prefix,
          urgentRequest: false,
          reserve: false
        };
      }
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'test-lamella-request') {
      title = 'Test lamella request';
      const prefix = _.get(props, 'websocket.modalmanager.submodalInfo.modal-edit.data.prefix', '');
      let usedPrefix = '';
      if (prefix.length > 0) {
        usedPrefix = prefix + '-';
      }
      newState.item = {
        lamellaLength: _.get(productionstatus, 'globalSettings.testLamellaLength', 0),
        numLamellas: 1,
        lamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaWidth', 0),
        lamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaThickness', 0),
        plannedLamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedWidth', 0),
        plannedLamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedThickness', 0),
        quality: _.get(productionstatus, usedPrefix + 'producing.quality', ''),
        FJMachine: prefix,
        urgentRequest: false
      };
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'waste-lamella-request') {
      title = 'Waste lamella request';
      const prefix = _.get(props, 'websocket.modalmanager.submodalInfo.modal-edit.data.prefix', '');
      let usedPrefix = '';
      if (prefix.length > 0) {
        usedPrefix = prefix + '-';
      }
      newState.item = {
        lamellaLength: _.get(productionstatus, 'globalSettings.wasteLamellaLength', 0),
        numLamellas: 0,
        lamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaWidth', 0),
        lamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaThickness', 0),
        plannedLamellaWidth: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedWidth', 0),
        plannedLamellaThickness: _.get(productionstatus, usedPrefix + 'producing.lamellaPlannedThickness', 0),
        quality: _.get(productionstatus, usedPrefix + 'producing.quality', ''),
        FJMachine: prefix,
        urgentRequest: false
      };
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }

    if (string === 'set-settings') {
      title = 'Set Settings';
      if (productionstatus?.globalSettings != undefined) {
        newState.item = generateGlobalSettingsFromControl(productionstatus.globalSettings);
        newState.view = generateViewObject(newState.item, 0, [], true);
        return newState;
      }
    }
    if (string === 'set-infeed-package') {
      title = 'Set Infeed Package';
      newState.item = props.pack;
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'set-RCStack') {
      console.log('set-RCStack: ', props);
      title = 'Set RCStack';
      newState.item = productionstatus.RCStack[props.part];
      newState.item.index = props.part;
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'set-editjd') {
      title = 'Set JD';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true, cherryPick);
      return newState;
    }
    if (string === 'set-editpackage') {
      title = 'Set Package';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'set-editproduct') {
      title = 'Set Package';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }
    if (string === 'set-editLayer') {
      title = 'Set Layer';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true);
      return newState;
    }

    if (string === 'set-editControlOrder') {
      title = 'Set ControlOrder';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true);
      newState.activeItems = [];
      return newState;
    }

    if (string === 'general-edit') {
      title = 'General edit';
      newState.item = props.websocket.modalmanager.submodalInfo['modal-edit'].data;
      newState.view = generateViewObject(newState.item, 0, [], true);
      newState.activeItems = [];
      return newState;
    }

    return newState;
  }

  function generateViewObject(item, level, path, init) {
    const view = {};
    for (const property in item) {
      const allowed = checkIfAllowed(level, property);

      switch (typeof item[property]) {
        case 'boolean':
        case 'string':
        case 'number':
          if (allowed) {
            view[property] = {
              type: typeof item[property],
              value: item[property],
              level,
              path: path.concat([property]),
              infoMessage: showInfo ? property + '-info' : false,
              infoMessageBadge: property + '-info'
            };
          }
          break;
        case 'object':
          if (allowed) {
            if (item[property] === null) {
              // if object and null assume it's a string for now
              view[property] = {
                type: 'string',
                value: '',
                level,
                path: path.concat([property])
              };
            } else {
              view[property] = {
                type: typeof item[property],
                value: null,
                level,
                path: path.concat([property])
              };
              const temp = generateViewObject(item[property], level + 1, path.concat([property]), false);
              view[property].value = temp;
            }
          }
          break;
        default:
          if (allowed) {
            view[property] = {
              type: 'string',
              value: '',
              level,
              path: path.concat([property])
            };
          }
      }
    }

    return view;
  }

  function changeValue(path, value) {
    const stateClone = cloneDeep(newState.item);

    const nestedObject = path.slice(0, -1).reduce((object, part) => (object === undefined ? undefined : object[part]), stateClone);

    if (nestedObject !== undefined) {
      const [pathTail] = path.slice(-1);

      if (value === true) {
        const field = newState.fields?.find((item) => item.key === pathTail);
        if (field?.exclusiveWith) _.set(stateClone, field.exclusiveWith, false);
      }

      if (_.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]) && value !== '') {
        const { fromUnit, toUnit, unitType } = _.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]);
        value = convertUnit(value, unitType, toUnit, fromUnit, 3);
      }

      nestedObject[pathTail] = value; // Allow empty values to be set
    }

    setNewState((prevState) => ({
      ...prevState,
      item: stateClone,
      view: generateViewObject(stateClone, 0, [], true)
    }));
  }

  function getInputFromItem(viewitem, property) {
    if (_.get(fieldIDs, viewitem.path, undefined) === undefined) {
      fieldIDs[viewitem.path] = getValue(viewitem.path);
    }

    const inputId = viewitem.path;
    const tempValue = _.get(tempValues, inputId, null) ?? getValue(viewitem.path);
    let convertedValue = '';
    const pathTail = inputId[inputId.length - 1];
    if (_.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]) && tempValue !== '') {
      const { fromUnit, toUnit, unitType } = _.get(conversionsConfig, [process.env.REACT_APP_PROJECT_NAME, pathTail]);
      convertedValue = convertUnit(tempValue, unitType, fromUnit, toUnit, 3);
    }

    const handleInputChange = (event) => {
      const value = event?.target?.value ?? event;
      handleTempValueChange(inputId, value);
    };

    const options = newState.fields?.find((field) => field.key === property)?.options;
    if (Array.isArray(options)) {
      return (
        <TextField select fullWidth key={'input' + viewitem.path} id={inputId} onChange={handleInputChange} label={generateNameFromProperty(property)} value={tempValue} size="small">
          {options.map((option) => (
            <MenuItem key={option || 'none'} value={option}>
              {option || 'None'}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    return (
      <Input
        className-={'MuiInputBase-input MuiOutlinedInput-input'}
        enabled
        key={'input' + viewitem.path}
        editable={true}
        id={inputId}
        helperText={tempValue === '' ? <FormattedMessage {...globalMessages.emptyError} /> : []}
        error={/* tempValue === '' */ false}
        onChange={handleInputChange}
        label={generateNameFromProperty(property)}
        value={convertedValue || tempValue}
        size={'small'}
      />
    );
  }

  function generateGlobalSettingsFromControl(globalSettings) {
    const createdGlobalSettings = {};
    Object.keys(globalSettings).forEach((key) => {
      createdGlobalSettings[key] = globalSettings[key] ?? 0;
    });
    if (hasDailyStatsSettings && globalSettings.dailyStatsBaseColor == null) {
      Object.assign(createdGlobalSettings, dailyStatsColorDefaults);
    }
    return createdGlobalSettings;
  }

  function generateNameFromProperty(property) {
    const configuredField = newState.fields?.find((field) => field.key === property);
    const messageKey = configuredField?.messageKey ?? property;
    return globalMessages[messageKey] ? <FormattedMessage {...globalMessages[messageKey]} identifier={messageKey} /> : property;
  }

  function getValue(path) {
    let item = newState.item;
    let lastPath = '';
    for (let i = 0; i < path.length; i++) {
      item = item[path[i]];
      lastPath = path[i];
    }

    if (item === 0) item = '0';
    if (item == null) item = 'null';
    return item;
  }

  function generateOrderView(view, generateObjects = false) {
    const booleanViewArrayOrder = [];
    const otherViewArrayOrder = [];
    const viewArrayLayer = [];
    const [expandedIndex, setExpandedIndex] = useState(null);
    const layerPropertyFilter = hasLayerInfoFieldsConfig ? (property) => layerInfoCherryPick.includes(property) : () => true;

    const handleAccordionToggle = (index) => {
      setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    for (const property in view) {
      if (property !== 'layers') {
        if (view[property].type === 'object' && generateObjects) {
          otherViewArrayOrder.push(
            <b key={property}>
              <InputLabel>{property}</InputLabel>
            </b>
          );
          otherViewArrayOrder.push(generateView(view[property].value, generateObjects));
        } else if (view[property].type === 'object' && !generateObjects) {
          continue;
        } else {
          const viewitem = view[property];
          switch (viewitem.type) {
            case 'boolean':
              booleanViewArrayOrder.push(
                <div key={property} classname="genv">
                  <PropertyField>
                    <CustomInputLabel style={{ minHeight: '38px' }}>{generateNameFromProperty(property)}</CustomInputLabel>
                    <CustomCheckbox
                      style={{ textAlign: 'center' }}
                      name={String(view[property].path)}
                      id={String(view[property.path])}
                      checked={view[property].value}
                      onClick={(e) => changeValue(viewitem.path, e.target.checked)}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                    {action === 'set-settings' ? (
                      <WithInfo translationKey={view[property].infoMessageBadge} topOffset="-20px" rightOffset="-8px" wrapperStyle={{ position: 'absolute', top: 0, right: 0 }}>
                        <span style={{ width: '10px', height: '10px', display: 'inline-block' }}></span>
                      </WithInfo>
                    ) : (
                      <InfoButton infoText={view[property].infoMessage} />
                    )}
                  </PropertyField>
                  <br />
                </div>
              );
              break;
            default:
              otherViewArrayOrder.push(
                <div key={property} className="genv">
                  <div>
                    <PropertyField>
                      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <InfoButton style={{ marginBottom: '15px' }} infoText={view[property].infoMessage} />
                      </div>
                      {getInputFromItem(viewitem, property)}
                    </PropertyField>
                  </div>
                  <br />
                </div>
              );
          }
        }
      } else {
        for (let i = 0; i < Object.keys(view[property].value).length; i++) {
          viewArrayLayer.push(
            <AccordionItem
              key={i}
              onExpand={() => handleAccordionToggle(i)}
              onClose={() => handleAccordionToggle(i)}
              title={
                <div className="layerBtn">
                  Layer {i + 1}
                  {expandedIndex === i ? <ExpandLess className="icon" /> : <ExpandMore className="icon" />}
                </div>
              }
              collapsed={expandedIndex !== i}
              style={{ marginLeft: '10px' }}>
              {generateView(view[property].value[i].value, false, layerPropertyFilter)}
            </AccordionItem>
          );
        }
      }
    }
    return (
      <EditOrderView style={{ maxHeight: '100%', height: '100%' }}>
        <div style={{ width: '100%', display: 'flex', height: '100%' }}>
          <div style={{ width: '50%' }}>
            <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', fontSize: '1.5em', fontWeight: 'bold' }}>
              <FormattedMessage {...globalMessages.orderInfo} identifier={'orderInfo'} />
            </div>
            <div>
              <div style={{ display: 'flow', flexWrap: 'wrap' }}>
                <div style={{ flex: '1', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>{otherViewArrayOrder}</div>
                <div style={{ flex: '2', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>{booleanViewArrayOrder}</div>
              </div>
            </div>
          </div>
          <div style={{ width: '2px', background: 'rgba(0, 0, 0, 0.3)', minHeight: '100%' }} />
          <div style={{ width: '50%' }}>
            <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', fontSize: '1.5em', fontWeight: 'bold' }}>
              <FormattedMessage {...globalMessages.layerInfo} identifier={'layerInfo'} />
            </div>
            <div className="accord">
              <Accordion>{viewArrayLayer}</Accordion>
            </div>
          </div>
        </div>
      </EditOrderView>
    );
  }

  function generateView(view, generateObjects = true, propertyFilter = () => true) {
    const booleanElements = [];
    const otherElements = [];

    for (const property in view) {
      if (!propertyFilter(property)) {
        continue;
      }

      if (view[property].type === 'object' && generateObjects) {
        otherElements.push(
          <b key={property}>
            <InputLabel>{property}</InputLabel>
          </b>
        );
        otherElements.push(generateView(view[property].value, generateObjects, propertyFilter));
      } else if (view[property].type === 'object' && !generateObjects) {
        continue;
      } else {
        const viewitem = view[property];
        switch (viewitem.type) {
          case 'boolean':
            booleanElements.push(
              <div key={property} className="genv">
                <PropertyField>
                  <CustomInputLabel style={{ minHeight: '38px' }}>{generateNameFromProperty(property)}</CustomInputLabel>
                  <CustomCheckbox
                    style={{ textAlign: 'center' }}
                    name={String(view[property].path)}
                    id={String(view[property.path])}
                    checked={view[property].value}
                    onClick={(e) => changeValue(viewitem.path, e.target.checked)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                  {action === 'set-settings' ? (
                    <WithInfo translationKey={view[property].infoMessageBadge} topOffset="-20px" rightOffset="-8px" wrapperStyle={{ position: 'absolute', top: 0, right: 0 }}>
                      <span style={{ width: '10px', height: '10px', display: 'inline-block' }}></span>
                    </WithInfo>
                  ) : (
                    <InfoButton infoText={view[property].infoMessage} />
                  )}
                </PropertyField>
                <br />
              </div>
            );
            break;
          default:
            otherElements.push(
              <div key={property} className="genv">
                <PropertyField>
                  {action === 'set-settings' ? (
                    <WithInfo translationKey={view[property].infoMessageBadge} topOffset="-16px" rightOffset="-6px" wrapperStyle={{ position: 'absolute', top: 0, right: -8 }}>
                      <span style={{ width: '10px', height: '10px', display: 'inline-block' }}></span>
                    </WithInfo>
                  ) : (
                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                      <InfoButton style={{ marginBottom: '15px' }} infoText={view[property].infoMessage} />
                    </div>
                  )}
                  {getInputFromItem(viewitem, property)}
                </PropertyField>
                <br />
              </div>
            );
        }
      }
    }

    return (
      <div style={{ display: 'flow', flexWrap: 'wrap' }}>
        <div style={{ flex: '1', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>{otherElements}</div>
        <div style={{ flex: '2', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>{booleanElements}</div>
      </div>
    );
  }

  function generateViewWithTabs(view) {
    if (!view) return null;
    const tabs = [];
    const tabContents = [];

    tabs.push('generalSettings');
    tabContents.push(generateView(view, false, (property) => !hasDailyStatsSettings || !dailyStatsFields.includes(property)));

    if (hasDailyStatsSettings) {
      dailyStatsFields.forEach((key) => { fieldIDs[key] = getValue([key]); });
      tabs.push('dailyStatsSettings');
      tabContents.push(
        <DailyStatsSettings item={{ ...newState.item, ...tempValues }} errors={settingsErrors} onChange={(key, value) => handleTempValueChange([key], value)} />
      );
    }

    for (const property in view) {
      if (view[property].type === 'object') {
        tabs.push(property);
        tabContents.push(generateView(view[property].value));
      }
    }

    const handleTabChange = (event, newValue) => {
      setTabIndex(newValue);
    };

    return (
      <div>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="settings tabs"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          textColor="primary"
          TabIndicatorProps={{ style: { background: '#f9b115' } }}
          sx={{ '& .MuiTab-root.Mui-selected': { color: '#000015' } }}>
          {tabs.map((tab, index) => (
            <Tab label={<FormattedMessage {...globalMessages[tab]} identifier={tab} />} key={index} />
          ))}
        </Tabs>
        {tabContents.map((content, index) => (
          <TabPanel value={tabIndex} index={index} key={index}>
            {content}
          </TabPanel>
        ))}
      </div>
    );
  }

  function sendToControl(editObject) {
    let changedsettings = JSON.parse(JSON.stringify(editObject));
    let usedDefaultPayloadHandling = true;

    if (props.action === 'extra-lamella-request') {
      const extraLamellaFields = _.get(jdqueueConfig, 'extraLamellaRequest.fields', []);

      if (Array.isArray(extraLamellaFields) && extraLamellaFields.length > 0) {
        changedsettings = extraLamellaFields.reduce((acc, field) => {
          if (!field?.key) return acc;

          _.set(acc, field.key, _.get(editObject, field.key));
          const changedValue = _.get(tempValues, [field.key], null);
          if (changedValue != null) {
            _.set(acc, field.key, changedValue);
          }

          return acc;
        }, {});

        if (_.get(props, 'machineId', false)) {
          changedsettings.machineId = props.machineId;
        }

        usedDefaultPayloadHandling = false;
      } else {
        // Iterate over fieldIDs and apply changes to the settings object
        for (const key in fieldIDs) {
          const fieldPath = key.split(',');
          const changedValue = _.get(tempValues, fieldPath, null);
          const needsChange = changedValue != null;
          if (needsChange) _.set(changedsettings, fieldPath, changedValue);
        }
      }
    } else {
      // Iterate over fieldIDs and apply changes to the settings object
      for (const key in fieldIDs) {
        const fieldPath = key.split(','); // Split nested keys by comma
        //  let rawValue = document.getElementById(key)?.value || '';
        const changedValue = _.get(tempValues, fieldPath, null);
        const needsChange = changedValue != null;
        if (needsChange) _.set(changedsettings, fieldPath, changedValue); // Set raw value in nested structure
      }
    }

    if (hasDailyStatsSettings) {
      const errors = validateDailyStatsColors(changedsettings);
      setSettingsErrors(errors);
      if (Object.keys(errors).length) {
        setTabIndex(1);
        return;
      }
      changedsettings = normalizeDailyStatsColors(changedsettings);
    }

    // Add machineId if available
    if (_.get(props, 'machineId', false) && usedDefaultPayloadHandling) {
      changedsettings.machineId = props.machineId;
    }

    // Dispatch the WebSocket action
    const wsActionIdentifier = _.get(changedsettings, 'additionalParameters.wsAction', props.action);
    dispatch(sendToWs(changedsettings, wsActionIdentifier));

    return true;
  }

  return (
    <Modal>
      <ModalHeader>
        Edit
        <XButton closeFn={props.closeFn} closeCallback={props.closeCallback} />
      </ModalHeader>
      <ModalContent>
        {props.action && props.action === 'set-editControlOrder' ? (
          <div style={{ padding: '1rem', width: '100%', height: '100%' }}>{generateOrderView(newState.view)}</div>
        ) : props.action && props.action === 'set-settings' ? (
          <div style={{ padding: '1rem', width: '100%' }}>{generateViewWithTabs(newState.view)}</div>
        ) : (
          <div style={{ padding: '1rem', width: '100%' }}>{generateView(newState.view)}</div>
        )}
      </ModalContent>
      <ModalFooter>
        <Button
          size="small"
          variant="contained"
          color="success"
          onClick={() => {
            if (sendToControl(newState.item)) props.closeFn(props.closeCallback);
          }}
          sx={{ mr: 0 }}>
          <FormattedMessage {...globalMessages.save} identifier={'save'} />
        </Button>
        <Button size="small" variant="contained" color="error" onClick={() => props.closeFn(props.closeCallback)} sx={{ mr: 0 }}>
          <FormattedMessage {...globalMessages.closebtn} identifier="closebtn" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

EditControlModal.propTypes = {
  orderFields: PropTypes.array,
  status: PropTypes.object,
  item: PropTypes.object,
  closeFn: PropTypes.func,
  pack: PropTypes.object,
  id: PropTypes.number
};

const mapStateToProps = createStructuredSelector({
  editcontrol: makeEditControlQueue(),
  websocket: selectWebsocket(),
  loginState: makeSelectLoginState()
});

function mapDispatchToProps(dispatch) {
  return {
    // setCompartment: () => dispatch(setCompartment()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(EditControlModal);
